/* =========================================================
   custom-dark-mode.js
   Maneja el clic del botón y recuerda la preferencia del usuario.
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-theme-toggle]');
  if (!toggle) return;

  var root = document.documentElement;

  function syncState() {
    var isDark = root.getAttribute('data-theme') === 'dark';
    toggle.setAttribute('aria-checked', isDark ? 'true' : 'false');
  }

  syncState();

  toggle.addEventListener('click', function () {
    var current = root.getAttribute('data-theme');
    var next = current === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try {
      localStorage.setItem('bw-theme', next);
    } catch (e) {
      /* localStorage puede fallar en modo incógnito en algunos navegadores; no es crítico */
    }
    syncState();
  });
});
